// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DQzg","colMin":"styles_colMin__2RUx-"};